import React from 'react';
import { LandingPage } from './pages/LandingPage';
import { useMetaPixel } from './hooks/useMetaPixel';
import { META_PIXEL_ID } from './data/config';
type AppProps = {
  guaranteeEnabled?: boolean;
  testimonialsEnabled?: boolean;
  salesPopupEnabled?: boolean;
};
export function App({
  guaranteeEnabled = true,
  testimonialsEnabled = true,
  salesPopupEnabled = true
}: AppProps) {
  useMetaPixel(META_PIXEL_ID);
  return <LandingPage guaranteeEnabled={guaranteeEnabled} testimonialsEnabled={testimonialsEnabled} salesPopupEnabled={salesPopupEnabled} data-id="element-0" data-mp="2rlp0msn6qhec" />;
}